import { onAuthStateChanged, signOut } from "firebase/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, getUser } from "../firebase/firebase";
import { PROJECT_APP, ECINNOVA, INSERTATOLEDO, CARITASTOLEDO, colorProject } from "../js/project";
import Footer from "../components/controlhorarioadmin/Footer";
import HeaderLoading from "../components/controlhorariotrabajadores/HeaderLoading";

export function Update() {
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (!user) navigate("/login")
      else {
        const userDB = await getUser(user.uid);

        if (userDB.estado === false) {
          logout()
        } 
        else if (userDB.primerAcceso === true) {
          navigate("/changePassword")
        } 
        else if (userDB.admin === false) {
          navigate("/controlHorario")
        } 
        else if (userDB.admin === true) {
          if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
            navigate("/admin")
          }
          if (PROJECT_APP === CARITASTOLEDO) {
            navigate("/controlHorario")
          }
        }
      }
    });
  }, [navigate]);

  function logout() {
    signOut(auth)
      .then(() => {
        // console.log("OUT");
      })
      .catch((error) => {
        // console.error(error);
        // console.log("error logout");
      });

    //console.log("OUT");
    //auth().logout();
    //window.location.href = "login.html";
  }

  return (
    <div style={{backgroundColor: colorProject}}>
      <div className="container1140px bgwhite">
        <HeaderLoading />
        <div className="vp100h">
          &nbsp;
          {/* <ListaTrabajadoresLoading /> */}
        </div>
        <Footer />
      </div>
    </div>
  );  
}
